<template>
  <base-edit :fields="isProvider ? providerFields : makerFields"
             :resourceName="resourceName" :pk="pk" :breadcrumbs="breadcrumbs">
    <template slot="standards" slot-scope="{ input }">
      <TextList
              :input.sync="input"
              :resourceName="resourceName"
              mode="edit"
              placeholder="50g 約30枚, 1kg 約60枚"
      />
    </template>
    <template slot="allergens" slot-scope="{ input }">
      <TextList
              :input.sync="input"
              :resourceName="resourceName"
              mode="edit"
              :required="true"
              name="アレルギー情報"
              placeholder="小麦, 卵"
      />
    </template>
    <template slot="nutrient_facts" slot-scope="{ input }">
      <TextList
              :input.sync="input"
              :resourceName="resourceName"
              mode="edit"
              placeholder="エネルギー 149kcal, タンパク質 5.2g"
      />
    </template>
    <template slot="origins" slot-scope="{ input }">
      <TextList
              :input.sync="input"
              :resourceName="resourceName"
              mode="edit"
              placeholder="イタリア"
      />
    </template>
    <template slot="keywords" slot-scope="{ input }">
      <TextList
              :input.sync="input"
              :resourceName="resourceName"
              mode="edit"
      />
    </template>
  </base-edit>
</template>

<script>
  import TextList from '../../components/field/text-list';

export default {
  components: {
    TextList
  },
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    const commonColumns =[
      {
        label: "商品名",
        name: "name",
        rules: "required|max:255",
        placeholder: "RBEラザニア",
        width: "60%"
      },
      {
        label: "商品名かな",
        name: "name_kana",
        rules: "max:255|kana_alpha_num",
        placeholder: "あーるびーえこーらざにあ",
        width: "60%"
      },
      {
        label: "商品ID",
        name: "jan_code",
        rules: "max:13",
        placeholder: "JANコードもしくは共通IDにて管理してる場合入力",
        width: "60%"
      },
      {
        label: "商品画像",
        name: "images",
        type: "custom",
        rules: "required"
      },
      {
        label: "商品紹介",
        type: "textarea",
        name: "description",
        rules: "required",
        placeholder: "平たい板状のラザニア用パスタ。商品の特徴である縁の部分が波打っている形状は、より多くのソースを絡める役割も持っており、ベシャメルソースの代わりにリコッタチーズを使ったナポリ風、ラグーソース、たっぷりのチーズとベシャメルソースを合わせたボローニャ風など全てのジャンルにお勧めです。また、この素材はデュラム小麦の高品質の部分のみを使用、500年の伝統を誇るイタリア製法で製造されています。ソースの水分を吸収して柔らかくなりますので、ソースに重ねてオーブンで焼くだけ、茹でずに使用可能です。",
        width: "100%"
      },
      {
        label: "商品カテゴリー（大）",
        name: "large_category_id",
        type: "select",
        rules: "required",
        optionType: "common/product_large_categories",
        width: "60%"
      },
      {
        label: "商品カテゴリー（中）",
        name: "medium_category_id",
        rules: "required",
        type: "select",
        optionType: "common/product_medium_categories",
        width: "60%"
      },
      {
        label: "内容量",
        type: "textarea",
        name: "net_content",
        rules: 'required',
        placeholder: "1kg (約17cm×約9cm 約60枚)",
        width: "100%"
      },
      {
        label: "容器",
        type: "textarea",
        name: "container",
        rules: 'required',
        placeholder: "パック",
        width: "100%"
      },
      {
        label: "賞味期限",
        type: "textarea",
        name: "best_before",
        placeholder: "製造後2年",
        width: "100%"
      },
      {
        label: "温度帯",
        type: "textarea",
        name: "temperature_zone",
        rules: 'required',
        placeholder: "常温場所にて、高温、直射日光は避けて下さい。",
        width: "100%"
      },
      {
        label: "規格一覧",
        name: "standards",
        type: "custom",
        width: "100%"
      },
      {
        label: "その他情報",
        type: "textarea",
        name: "others",
        placeholder: "デュラムセモリナ、卵 \n※細かな斑点はデュラム小麦のセモリナに由来するもので品質には問題ございません。",
        width: "100%"
      },
      {
        label: "アレルギー情報",
        name: "allergens",
        type: "custom",
        rules: 'required',
        width: "100%"
      },
      {
        label: "栄養成分",
        name: "nutrient_facts",
        type: "custom",
        width: "100%"
      },
      {
        label: "原料原産地",
        name: "origins",
        type: "custom",
        width: "100%"
      },
      {
        label: "サンプル対応可",
        name: "providing_samples",
        type: "checkbox",
        textKey: "label",
        valueKey: "value",
        selects: [
          {
            label: "対応可",
            value: 1
          }
        ]
      },
      {
        label: "サンプル出荷単位",
        name: "sample_quantity",
        type: "custom",
        rules: "max:255",
        placeholder: "1g, 1kg, 1本, 1個, 1つ",
        width: "60%"
      },
      {
        label: "レビューテンプレートID",
        name: "review_set_id",
        type: "select",
        rules: "required_if:providing_samples,1",
        optionType: "common/review_sets",
        width: "60%"
      },
      {
        label: "公開",
        name: "published",
        type: "checkbox",
        textKey: "label",
        valueKey: "value",
        selects: [
          {
            label: "公開",
            value: 1
          }

        ]
      },
      {
        label: "有償サンプルフラグ",
        name: "sample_paid",
        type: "checkbox",
        textKey: "label",
        valueKey: "value",
        selects: [
          {
            label: "有償",
            value: 1
          }
        ]
      },
      {
        label: "サンプル価格",
        name: "sample_price",
        rules: 'numeric',
        type: 'currency',
        unit: "円",
        placeholder: "0",
        width: "30%"
      },
      {
        label: "会員限定フラグ",
        name: "user_plan_only",
        type: "checkbox",
        textKey: "label",
        valueKey: "value",
        selects: [
          {
            label: "会員限定",
            value: 1
          }

        ]
      }
    ];

    return {
      resourceName: "products",
      providerFields:
        [
          {
            label: "提供メーカー",
            name: "maker_id",
            type: 'select',
            rules: "required",
            optionType: "common/makers",
            width: "60%"
          },
          ...commonColumns
        ],
      makerFields: commonColumns
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "商品一覧",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: "商品編集",
          disabled: true
        }
      ];
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    }
  }

};
</script>
